export default "__VITE_ASSET__BJj$fy_Z__"